import { resolvePath } from './resolvePath';
export function resolveBindKey(value, namespaces, loopItem) {
  if ('$bindKey' in value) {
    const resolved = resolvePath(value.$bindKey, namespaces, loopItem);
    return resolved !== undefined ? String(resolved) : undefined;
  }
  const path = value.$bind;
  if (path.startsWith('context.')) return path.slice('context.'.length);
  return undefined;
}